export default __webpack_public_path__ + "static/media/SearchTalent.c82c3ac2.svg";